<template>
    <b-overlay :show="tableLoading" rounded="sm">
        <b-card class="p-0 mt-3">

            <b-col class="page-block">
                <strong>
                    {{ $translate("page") }}: {{ pagination.page }}
                    {{ $translate("of") }} {{ pageCount }} {{ $translate("total") }}:
                    {{ pagination.total }}
                </strong>
            </b-col>
            <b-card-header class="assets-filter">
                <b-row class="mt-3">
                    <b-col cols="12" md="12">
                        <div class="d-flex">
                            <b-button id="filter-toggle-btn" variant="blue-button" class="me-2" @click="toggle_filters = !toggle_filters">
                                {{ $translate('filters') }}
                                <b-icon class="ms-1" :icon="'chevron-' + (toggle_filters ? 'up' : 'down')"
                                    variant="dark"></b-icon>
                            </b-button>
                            <b-button id="reset-filter-btn" variant="blue-button" @click="resetFilters" v-b-tooltip.hover
                                :title="$translate('reset_filters')">
                                <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                            </b-button>
                             <b-button id="export-excel-btn" variant="blue-button" @click="exportData" v-b-tooltip.hover
                                :title="$translate('export_data')" class="mx-2 float-right">
                                {{ $translate('excel') }}
                            </b-button>
                            <b-button id="export-dashboard-btn" variant="blue-button" @click="exportDashboard" v-b-tooltip.hover
                            :title="$translate('export_dashboard')" class="mx-2 float-right">
                            {{ $translate('dashboard') }}
                           </b-button>
                            <!-- <b-button variant="blue-button" @click="pdfData" v-b-tooltip.hover
                                :title="$translate('pdf_data')" class="float-right">
                                <b-icon icon="printer-fill" variant="dark"></b-icon>
                            </b-button> -->
                        </div>
                    </b-col>
                    <!-- <b-col cols="12" md="6" class="p-0 pe-md-3 d-flex text-right align-items-center">
                        <slot></slot>
                    </b-col> -->
                </b-row>
                <QueryFilters v-show="toggle_filters" v-model="filters" :customer-agents="customerAgents" :officers="officers" :order-types="orderTypes" />
            </b-card-header>
            <b-card-body >
                <b-col class="overflow-auto w-100" >
                    <b-table :fields="fields" responsive :items="items" :per-page="itemsPerPage"
                        :current-page="currentPage" :filter="filters" :sort-by.sync="sortBy" 
                        :sort-desc.sync="sortDesc" show-empty>
                        <template #table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </template>
                        <template #cell(description)="{ item }">
                            <p class="m-0 opp-description" v-if="item.description !=null">
                               
                                <span v-if="!isExpanded(item.id)">{{ truncatedDescription(item.description) }}</span>
                                <span v-else>{{ item.description }}</span>
                                <span 
                                  v-if="item.description.length > 50" 
                                  @click="toggleDescription(item.id)" 
                                  class="expand"
                                >
                                  {{ isExpanded(item.id) ? ' Show less' : '... Show more' }}
                                </span>
                              </p>
                              
                        </template>
                        <template #cell(customer_name)="{ item }">
                            <p class="m-0"></p>
                            <p class="m-0">{{ item.customer?.name }}({{ item.customer?.code }})</p>
                           
                        </template>
                       
                        <template #cell(reference_no)="{ item }">
                          
                            <b-link :to="`/ams/activities/${item.id}`">
                                {{ item.reference_no }}
                            </b-link>
                        </template>
                        <template #cell(last_update)="{ item }">
                            <p class="m-0 opp-description" v-if="item.last_update!=null">
                                
                                <span v-if="!isExpanded(item.id+'_msg')"><pre class="custom-pre">{{ truncatedDescription(item.last_update.content) }}</pre></span>
                                <span v-else><pre class="custom-pre">{{item.last_update.content }}</pre></span>
                                
                                <span 
                                  v-if="item.last_update.content.length > 50" 
                                  @click="toggleDescription(item.id+'_msg')" 
                                  class="expand"
                                >
                                  {{ isExpanded(item.id+'_msg') ? ' Show less' : '... Show more' }}
                                </span>
                              </p>
                          
                            <p class="m-0" v-if="item.last_update?.updated_at!=null">({{ displayLocalDateTime(item.last_update?.updated_at) }})</p>
                        </template>
                        <template #cell(current_address)="{ item }">
                            <div v-html="getFormattedAddress(item)"></div>
                        </template>
                        <template #cell(products_of_interests_count)="{ item }">
                            <b-link v-if="item.products_of_interests_count > 0" @click="setProductsOfInterestViewList(item)">{{ $translate('view') }}</b-link>
                        </template>
                        <template #cell(grand_total)="{ item }">
                            <div>{{ item.grand_total | currency }}</div>
                        </template>
                        <template #cell(forecast)="{ item }">
                            <div>{{ item.progress_status ? (parseFloat(item.grand_total || 0) * parseFloat(item.progress_status.status_value || 0)).toFixed(2) : '' | currency }}</div>
                        </template>
                        <template #cell(activity_health)="{ item }">
                            <div v-if="item.activity_health"
                                :style="{ backgroundColor: item.activity_health.color, width: '20px', height: '20px' }">
                            </div>
                            <p v-if="item.activity_health">{{ item.activity_health ? `${item.activity_health.title} (${item.activity_health.end})`: '' }}</p>
                        </template>
                        
                        <template #empty>
                            <div class="text-center">No Data Available</div>
                        </template>
                    </b-table>
                </b-col>
                <b-row>
                    <b-col>
                        <b-pagination class="justify-content-center mt-4" v-model="pagination.page"
                            :total-rows="pagination.total" :per-page="pagination.pageSize" aria-controls="customerTable"
                            :prev-text="$translate('previous')" :next-text="$translate('next')" pills
                            align="center"></b-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <ManageOpportunityProductsOfInterest ref="viewOpportunityProductsOfInterestItem" @item-added="evt => itemAdded(evt)"/>
    </b-overlay>
</template>
<script>
import moment from 'moment'
import dateTimeMixins from "@/mixins/dateTimeMixins";
import popupMixins from '@/mixins/popupMixins'
import addActivityTypeIcon from '@/assets/images/icon/blue-add.svg'
import permissionsMixins from '@/mixins/permissionsMixins'
import QueryFilters from './QueryFilters.vue'
import ManageOpportunityProductsOfInterest from "@/views/Orders/ManageOpportunityProductsOfInterest.vue";

const defaultModel = Object.freeze({
    due_from: moment().subtract(30, 'days').format('YYYY-MM-DD'),

    due_to: moment().format('YYYY-MM-DD'),
})

export default {
    name: 'OpportunityStatus',
    mixins: [popupMixins, permissionsMixins, dateTimeMixins],
    props: ['type', 'title'],
    components: { QueryFilters, ManageOpportunityProductsOfInterest },

    data() {
        return {
            query: "",
            toggle_filters: false,
            filters: {
                query: "",
                due_from: defaultModel.due_from,
                due_to: defaultModel.due_to,
                last_meeting_from: null,
                last_meeting_to: null,
                last_update_from: null,
                last_update_to: null,
                next_meeting_from: null,
                next_meeting_to: null,
                crm_opportunity_type_id: null,
                activity_health_id: null,
                customer_id: null,
                total_amount: null,
                quantityType: 3,
                type: null,
            },
            sortBy: 'crm_opportunity_type',
            sortDesc: false,
            icon: addActivityTypeIcon,
            itemsPerPage: 15,
            currentPage: 1,
            tableLoading: false,
            expandedItems: {}
        }
    },
    mounted() {
        const { query } = this.$route;
        if (query.query) this.query = query.query;

        if (query.q) delete query.q

        if (query.query)
            this.$set(this.filters, "query", query.query);

        if(this.$store.state.customers.crm_filters) {
            for(const key in this.$store.state.customers.crm_filters){
                const value = this.$store.state.customers.crm_filters[key];
                this.$set(this.filters, key, value)
            }
        }

        this.doSearch(true)

        this.$store.dispatch('crmOpportunityTypes/fetchAll'),
        this.$store.dispatch('health/fetch', { query: "", page: 0 })
    },
    async created(){
       await this.$store.dispatch("customerAgents/fetchAll");
       await this.$store.dispatch("orders/fetchDrivers");
    },
    filters: {
        currency: num => {
            num = parseFloat(num) || 0
            try {
                return '$' + num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
        filterStatusVariant(item) {
            let badgeClass = '';
            switch (item.payment_transaction_status) {
                case 'pending':
                    badgeClass = 'primary';
                    break;
                case 'processed':
                    badgeClass = 'success';
                    break;
                case 'cancelled':
                    badgeClass = 'danger';
                    break;

                default:
                    badgeClass = 'primary';
                    break;
            }
            return badgeClass;
        },
    },
    watch: {
        items: {
            handler: function () {
                // this.tableLoading = false
            },
            deep: true,
        },

        query: function(val){
            this.$set(this.filters, 'query', val);
        },

        filters: {
            handler: function (val) {
                if(val.sortBy == '') return;
                this.query = val.query
                this.doSearch(true)
            },
            deep: true,
        },

        "pagination.page": function () {
            this.doSearch();
        },
    },

    computed: {
        fields() {
            const { displayLocalDateTime, displayLocalDate } = this;
            return [
                // { key: 'id', label: this.$translate('actions') },
                {
                    key: 'description',
                    label: this.$translate('opportunity_name'),
                    tdClass: "order-table-description",
                    sortable: false,
                },
                {
                    key: 'customer_name',
                    label: this.$translate('customer_name'),
                    thStyle: { width: "14%", whiteSpace: "normal" },
                    tdClass: "order-table-description",
                    thClass: "order-table-description",
                    sortable: false,
                },
                {
                    key: 'reference_no',
                    label: this.$translate('reference_no'),
                    thStyle: { width: "14%", whiteSpace: "normal" },
                    tdClass: "order-table-description",
                    thClass: "order-table-description",
                    sortable: false,
                },
                {
                    key: 'lifecycle_stage',
                    label: this.$translate('lifecycle_stage'),
                    formatter: (value, key, item) => item.customer?.lifecycle_stage?.name,
                    sortable: true,
                },
                {
                    key: 'type',
                    label: this.$translate('activity_type'),
                    formatter: (value, key, item) => item.type?.name,
                    sortable: false,
                },
                {
                    key: 'crm_opportunity_type',
                    label: this.$translate('crm_opportunity_type'),
                    formatter: (value, key, item) => item.crm_opportunity_type?.name,
                    sortable: true,
                },
                {
                    key: 'products_of_interests_count',
                    label: this.$translate('products_of_interest'),
                    sortable: false,
                },
                
                {
                    key: 'activity_health',
                    label: this.$translate('activity_health'),
                    sortable: true,
                },
                {
                    key: 'grand_total',
                    label: this.$translate('total'),
                    sortable: true,
                },
                {
                    key: 'schedule_at',
                    label: `${this.$translate('due')} ${this.$translate('date')}`,
                    formatter: (value) => displayLocalDateTime(value),
                    sortable: true,
                },
                {
                    key: 'last_meeting',
                    label: this.$translate('last_meeting'),
                    formatter: (value) => displayLocalDate(value),
                    sortable: true,
                },
                {
                    key: 'last_update',
                    label: this.$translate('last_update'),
                    sortable: false,
                },
                {
                    key: 'next_meeting',
                    label: this.$translate('next_meeting'),
                    formatter: (value) => displayLocalDate(value),
                    sortable: false,
                },
                {
                    key: 'driver',
                    label: this.$translate('officer'),
                    formatter: (value) => value ? `${value.first_name} ${value.last_name}` : '',
                    sortable: false,
                },

                {
                    key: 'progress_status',
                    label: this.$translate('progress_status'),
                    formatter: (value) => value ? `${value.name}(${value.status_value})` : '',
                    sortable: false,
                },

                {
                    key: 'forecast',
                    label: this.$translate('forecast'),
                    sortable: false,
                },

                {
                    key: 'customer_agent_full_name',
                    label: this.$translate('customer_agent'),
                   
                    sortable: false,
                },

                {
                    key: 'customer_group',
                    label: this.$translate('customer_group'),
                    formatter: (value, key, item) => item.customer?.customer_group ? item.customer?.customer_group?.name : '',
                    sortable: false,
                },

                {
                    key: 'customer_segment',
                    label: this.$translate('customer_segment'),
                    formatter: (value, key, item) => item.customer?.customer_segment ? item.customer?.customer_segment?.name : '',
                    sortable: false,
                },
            ]
        },
        user() {
            return this.$store.state.user
        },

        orderTypes() {
            return this.$store.getters["orderType/activityTypesByPermission"];
        },
        customerAgents() {
            return this.$store.state.customerAgents.customer_agents;
        },
        officers() {
            return (this.$store.state.orders.drivers || []).map((x) => ({
                id: x.id,
                name: `${x.first_name} ${x.last_name}`.trim(),
            }));
        },

        rows() {
            return this.items.length
        },
        items() {
            // console.log('this is getting computed-', this.$store.state.asset_rental.items)
            const items = this.$store.state.customers.opportunity_status
            console.log('opportunity_status items', items)
            return items
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize);
        },
        pagination() {
            return this.$store.state.customers.opportunity_status_pagination || { page: 1 };
        },
    },

    methods: {
        resetFilters() {
            this.filters = {
                query: "",
                due_from: defaultModel.due_from,
                due_to: defaultModel.due_to,
                last_meeting_from: null,
                last_meeting_to: null,
                last_update_from: null,
                last_update_to: null,
                next_meeting_from: null,
                next_meeting_to: null,
                crm_opportunity_type_id: null,
                activity_health_id: null,
                customer_id: null,
                total_amount: null,
                quantityType: 3,
                type: null,
            }

            this.query = ''
            this.sortBy = 'crm_opportunity_type'
            this.sortDesc = false
            // this.doSearch()
        },
        async doSearch(isforcedReload = false) {

            let {
                query,
                pagination: { page },
                filters
            } = this

            if (query != "" && query.length < 3) return;

            page = parseInt(page) || 1;

            let type = "";
            if (filters.type && filters.type.length > 0 && Array.isArray(filters.type)) {
                type = filters.type.map((i) => i.id).join(",");
            }

            filters = {...filters, type};

            this.$router.push({
                query: { page, query, ...filters, type },
            });
            this.tableLoading = true
            try {
                await this.$store.dispatch('customers/fetchAllCrmOpportunityStatus', {
                    query,
                    filters,
                    page,
                    isforcedReload
                })
            } catch (err) {
                console.log('fetchAllCrmOpportunityStatus fetch Error: ', err);
                this.doToast(this.$translate('error'), err.message, 'danger')
            } finally {
                this.tableLoading = false
            }
        },
        async exportData() {


            let {
                query,
                filters
            } = this

            if (query != "" && query.length < 3) return;

            this.tableLoading = true
            await this.$store.dispatch('customers/fetchAllCrmOpportunityStatusExcel', {
                query,
                filters,
            })
            this.tableLoading = false
        },
        async exportDashboard(){
           let {
               query,
               filters
           } = this

           if (query != "" && query.length < 3) return;

           this.tableLoading = true
           await this.$store.dispatch('customers/fetchAllCrmOpportunityStatusDashboard', {
               query,
               filters,
           })
           this.tableLoading = false
         },
        async pdfData() {


            let {
                query,
                filters
            } = this

            if (query != "" && query.length < 3) return;

            this.tableLoading = true
            await this.$store.dispatch('asset_rental/exportPDF', {
                query,
                filters,
            })
            this.tableLoading = false
        },
        getFormattedAddress(item) {
            const location = item.asset?.location_section?.location;
            if (!location) {
                return ''; // Return an empty string if location is not available
            }

            const name = location.name || '';
            const address1 = location.address1 || '';
            const address2 = location.address2 || '';
            const city = location.city || '';
            const postal_code = location.postal_code || '';
            // Initialize an array to hold non-empty address parts
            const addressParts = [];

            // Add non-empty parts to the array
            if (name) addressParts.push(name);
            if (address1) addressParts.push(address1);
            if (address2) addressParts.push(address2);
            if (city) addressParts.push(city);
            if (postal_code) addressParts.push(postal_code);

            // Join the parts with '<br>' to create a formatted address
            return addressParts.join('<br>');
        },
        setProductsOfInterestViewList(order) {
            this.$refs['viewOpportunityProductsOfInterestItem'].listItem(order);
        },
    truncatedDescription(description) {
      if (description.length > 50) {
        return description.substring(0, 50);
      }
      return description;
    },
    toggleDescription(itemId) {
      this.$set(this.expandedItems, itemId, !this.expandedItems[itemId]);
    },
    isExpanded(itemId) {
        console.log('itemids======',this.expandedItems);
      return !!this.expandedItems[itemId];
    }
    },
}
</script>
<style>
.float-right {
    float: right !important;
}
.table.b-table>tfoot>tr>[aria-sort], .table.b-table>thead>tr>[aria-sort] {
    cursor: pointer;
    background-image: none;
    background-repeat: no-repeat;
    background-size: .65em 1em;
}
</style>
